<template>
    <v-simple-table dense class="w-100 pdf-content">
        <thead>
            <tr>
                <th>Orçamento</th>
                <th>Cliente</th>
                <th>Projeto</th>
                <th>Contato</th>
                <th>Fone</th>
                <th>Data/Soli</th>
                <th>Orçamentista</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="dado in dadosTabela" :key="dado._id" style="cursor: pointer;">
                <template v-if="!dado.revisoes">
                    <td>
                        {{ dado.codigo }}
                    </td>
                    <td>
                        {{ dado.clienteNome || "Cliente Não Informado" }}
                    </td>
                    <td>
                        -
                    </td>
                    <td>
                        {{  dado.contatoComercialNome }}
                    </td>

                    <td>
                        {{  dado.contatoComercialTelefone }}
                    </td>
                    <td>
                        {{ new Date(dado.dateGenerate).toLocaleDateString() }}
                    </td>
                    <td>
                        {{ dado.orcamentistaNome }}
                    </td>

                </template>

                <template v-else>
                    <td>
                        {{ dado.revisoes.codigo }}
                    </td>
                    <td>
                        {{ dado.revisoes.clienteNome || "Cliente Não Informado" }}
                    </td>
                    <td>
                        -
                    </td>
                    <td>
                        {{  dado.revisoes.contatoComercialNome }}
                    </td>

                    <td>
                        {{  dado.revisoes.contatoComercialTelefone }}
                    </td>
                    <td>
                        {{ new Date(dado.revisoes.dateGenerate).toLocaleDateString() }}
                    </td>
                    <td>
                        {{ dado.revisoes.orcamentistaNome }}
                    </td>
                </template>

            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: 'RelatorioSalesOrderTableView',
    props: ['dadosTabela'],
    data() {
        return {

        }
    }
}
</script>